var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Bases = /** @class */ (function (_super) {
    __extends(Bases, _super);
    function Bases() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Bases.prototype.render = function () {
        var _this = this;
        return (this.props.bases.map(function (base, index) {
            var activeClass = _this.props.activeBases.indexOf(base) !== -1 ? "rj-baseball-scoreboard-base--active" : "";
            var clsName = "rj-baseball-scoreboard-base rj-baseball-scoreboard-base-" + base + " " + activeClass;
            return (React.createElement("span", { className: clsName, key: _this.props.baseKey + "-base-" + index }));
        }));
    };
    return Bases;
}(React.PureComponent));
export { Bases };
//# sourceMappingURL=Bases.js.map